import { Grid } from '../Grid/Grid';
import { MbbSubscriptionSelectionSectionId } from '../OrderSubscriptionSelection/content/variables';
import { HorizontalMBBLiikkuvaWifiSubscriptions } from './HorizontalMBBLiikkuvaWifiSubscriptions';
import { HorizontalMBBYritysdataSubscriptions } from './HorizontalMBBYritysdataSubscriptions';
import type { OrderProps, PublicPageOrderProps, SubscriptionCardWithModel } from './types';
import type { MobileBroadbandSubCardProps } from '../SubscriptionCard/SubscriptionCard';

export interface HorizontalMobileBroadbandSubscriptionsProps {
  subscriptionCards: MobileBroadbandSubCardProps[];
  wide?: boolean;
  compact?: boolean;
  isChangeOffer?: boolean;
  onOrder: (p: PublicPageOrderProps | OrderProps) => void;
  getCard: (name: string) => SubscriptionCardWithModel | undefined;
  buttonText?: string;
  showDescriptions?: boolean;
  altDescription?: string;
  hasQuantity?: boolean;
  hideGroupHeaders?: boolean;
  eventOrigin: string;
}

export const HorizontalMobileBroadbandSubscriptions = (props: HorizontalMobileBroadbandSubscriptionsProps) => {
  return (
    <>
      <div id={MbbSubscriptionSelectionSectionId.YRITYSDATA_SUBS_ID}>
        <HorizontalMBBYritysdataSubscriptions {...props} hideGroupHeaders={true} />
      </div>
      {!props.isChangeOffer && (
        <Grid colWidthL={props.wide ? 12 : 10}>
          <div className="of-subscriptions-main-container">
            <div id={MbbSubscriptionSelectionSectionId.WIFI_SUBS_ID}>
              <HorizontalMBBLiikkuvaWifiSubscriptions {...props} />
            </div>
          </div>
        </Grid>
      )}
    </>
  );
};
